<template>
    <div style="display:flex; align-items:center; justify-content:center;  margin-top:-50px" v-if="productdetail">
        <div style="position:relative; width:816px; height:1056px; background:#fff;">

            <specsheet-header :prodstyle="productdetail.prod_key"></specsheet-header>
            <div style="padding: 50px 70px;">
                <p><span style="font-size:24px; line-height:28px; font-weight:500;">SKU Information</span></p>
                <specsheet-upc :product="productdetail" v-if="productdetail"></specsheet-upc>
            </div>
            <specsheet-footer></specsheet-footer>
        </div>
    </div>


</template>

<script>
import { mapState } from "vuex";

export default {
    data(){
        return {
            productdetail:{},
        }
    },
    created(){
        axios.get(`/api/productWithSku/${this.$route.params.id}`).then(response => {
           this.productdetail=response.data[0];
        });
    }
};
</script>
